import { fromJS } from 'immutable';
import actionTypes from '../../actions/actionTypes';

const INIT_STATE = fromJS({
    hidePrices: false
})

const onSuccess = (state, action) => state.set('hidePrices', !!action.payload.data.hidePrices)

const configReducer = (state = INIT_STATE, action) => {
    switch(action.type) {
        case actionTypes.EVENTS_ALL_SUCCESS:
            return onSuccess(state, action)
        default:
            return state
    }
}

export default configReducer;
